<template>
  <div class="appContainer d-flex flex-column justify-content-center align-items-center">
    <div class="content p-3">
      <img src="/logo.png" />
      <router-view></router-view>
    </div>

    <notifications group="errors" />
    <notifications group="successes" />
  </div>
</template>

<script>
import { eventBus } from "@/_infrastructure";

export default {
  methods: {
    notifyAboutError(error) {
      this.$notify({
        speed: 1,
        type: "error",
        group: "errors",
        title: "Błąd",
        text: error
      });
    },
    notifyAboutSucces(text) {
      this.$notify({
        speed: 1,
        type: "success",
        group: "successes",
        title: "Sukces",
        text: text
      });
    }
  },
  created() {
    var _self = this;

    eventBus.$on("unhandled-error", function(error) {
      var errorMsg = "Wystąpił nieokreślony błąd";
      var errorData = error.response.data;

      // tak, wielkosc znakow jest gdzies skopana..... Message z wielkiej, errors z malej
      if (errorData.Message) {
        errorMsg = errorData.Message;
      } else if (errorData.errors) {
        let tempMsg = "";
        for (var p in errorData.errors) {
          for (var pp in errorData.errors[p]) {
            tempMsg += errorData.errors[p][pp] + "<br/>";
          }
        }
        errorMsg = tempMsg;
      } else if (errorData) {
        errorMsg = errorData;
      }
      _self.notifyAboutError(errorMsg);
    });
    eventBus.$on("notify-success", function(text) {
      _self.notifyAboutSucces(text);
    });
  },
  destroyed() {
    eventBus.$off("unhandled-error");
    eventBus.$off("notify-success");
  }
};
</script>

<style lang="scss" scoped>
.appContainer {
  background: linear-gradient(rgba(#38ace3, 0.3), #ffffff);
  height: 100%;

  .content {
    box-shadow: 0px 0px 10px 0px rgba(#000000, 0.25);
    border-radius: 10px;
    background: rgba(#ffffff, 0.5);
    margin-left: 10px;
    font-size: 0.95rem;
    img {
      max-width: 250px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>